import {
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  Space,
  Switch,
  Tooltip,
} from 'antd';
import { useEffect, useState } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';

import style from './AddUser.module.css';
import Link from 'antd/es/typography/Link';
import { useTranslation } from 'react-i18next';
import { Platform } from '../../../../Models/PlatformManager/Platform';
import { StylingModule } from '../../../../Models/PlatformManager/StylingModule';
import { EspModule } from '../../../../Models/PlatformManager/EspModule';
import { RemoveButton } from '../../../../Components/Buttons/RemoveButton';

export function AddEspModuleForm(props: {
  allData?: EspModule[];
  data?: EspModule;
  open: boolean;
  onCancel: Function;
  onSafe: Function;
  onRemove: Function;
  onEdit: boolean;
}) {
  const [form] = Form.useForm();

  const { i18n, t } = useTranslation();

  const [removeItem, setRemoveItem] = useState(false);
  const [espModule, setEspModule] = useState<EspModule>();

  useEffect(() => {
    form.resetFields();
    setEspModule(props.data);
    setRemoveItem(false);
  }, [form, props.data, espModule]);

  const handleCancel = () => {
    props.onCancel();
  };

  const onFinishForm = (values: EspModule) => {
    if (props.data?.id !== undefined) {
      values.id = props.data?.id;
    }
    if (props.data?.idPlatform !== undefined) {
      values.idPlatform = props.data?.idPlatform;
    }
    if (props.data?.idUnit !== undefined) {
      values.idUnit = props.data?.idUnit;
    }

    if (removeItem) {
      props.onRemove(values);
    } else {
      props.onSafe(values);
    }
  };

  const onFinishFormFailed = (errorInfo: any) => {};

  const checkLabelExist = (_: any, value: string) => {
    var foundItem = props.allData?.find((x) => x.name === value);
    if (foundItem !== undefined) {
      if (foundItem.id === props.data?.id) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(t('nameexist').toString()));
    }
    return Promise.resolve();
  };

  const RenderRemoveButton = () => {
    var length = 0;
    if (espModule?.transputs) {
      length = espModule?.transputs.length;
    }

    if (espModule?.id) {
      return (
        <RemoveButton
          disabled={length > 0 ? true : false}
          textBtn={t('remove')}
          bindedFunction={setRemoveItem}
          bindedForm={form}
        ></RemoveButton>
      );
    }
    return <></>;
  };

  return (
    <Modal
      title={t('addespmodule')}
      open={props.open}
      onOk={() => form.submit()}
      okText={t('safe')}
      cancelText={t('cancel')}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {t('cancel')}
        </Button>,
        <>
          {RenderRemoveButton()}

          <Button key="submit" type="primary" onClick={() => form.submit()}>
            {t('safe')}
          </Button>
        </>,
      ]}
    >
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={props.data}
        onFinish={onFinishForm}
        onFinishFailed={onFinishFormFailed}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          label={t('name')}
          name="name"
          key="name"
          required
          rules={[
            {
              required: true,
              message: t('platformnamrequired').toString(),
            },
            { validator: checkLabelExist },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('moduleId')}
          name="moduleId"
          key="moduleId"
          rules={[{ required: true, message: t('fillsocketkey').toString() }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('enabled')}
          name="enabled"
          key="enabled"
          valuePropName="checked"
          rules={[{ required: true, message: t('fillsocketkey').toString() }]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label={t('styleIsOnline')}
          name="styleIsOnline"
          rules={[{ required: true, message: t('fillsocketkey').toString() }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
